package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import com.sweetlime.bingeamigo.util.format1f
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.presentation.ui.BrandColors

@Composable
fun RateReviewSheet(
    title: String,
    initialRating: Double,
    initialReview: String?,
    isLoading: Boolean = false,
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onSubmit: (rating: Double, review: String?) -> Unit
) {
    var rating by remember(initialRating) { mutableStateOf(initialRating.coerceAtLeast(0.5)) }
    var reviewText by remember(initialReview) { mutableStateOf(initialReview.orEmpty()) }

    AlertDialog(
        onDismissRequest = { if (!isSaving) onDismiss() },
        containerColor = Color(0xFF1E1E1E),
        title = {
            Text(
                text = if (initialRating > 0.0) "Edit rating" else "Rate $title",
                color = Color.White,
                style = MaterialTheme.typography.titleLarge
            )
        },
        text = {
            Column(
                verticalArrangement = Arrangement.spacedBy(16.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                modifier = Modifier.fillMaxWidth()
            ) {
                if (isLoading) {
                    CircularProgressIndicator(color = BrandColors.Primary)
                } else {
                    StarRatingBar(
                        rating = rating,
                        onRatingChange = { rating = it },
                        enabled = !isSaving,
                        starSize = 44.dp
                    )
                    Text(
                        text = "${rating.format1f()} / 5",
                        color = BrandColors.Primary,
                        style = MaterialTheme.typography.titleMedium
                    )
                }

                OutlinedTextField(
                    value = reviewText,
                    onValueChange = { if (it.length <= 500) reviewText = it },
                    placeholder = { Text("Write a review (optional)…", color = Color(0xFF666666)) },
                    modifier = Modifier.fillMaxWidth(),
                    minLines = 3,
                    maxLines = 6,
                    enabled = !isSaving,
                    supportingText = {
                        Text(
                            text = "${reviewText.length}/500",
                            color = if (reviewText.length >= 480) Color(0xFFFF6B35) else Color(0xFF666666),
                            style = androidx.compose.material3.MaterialTheme.typography.bodySmall,
                            modifier = Modifier.fillMaxWidth(),
                            textAlign = TextAlign.End
                        )
                    },
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedBorderColor = BrandColors.Primary,
                        unfocusedBorderColor = Color(0xFF444444),
                        focusedTextColor = Color.White,
                        unfocusedTextColor = Color.White,
                        cursorColor = BrandColors.Primary,
                        focusedSupportingTextColor = Color(0xFF666666),
                        unfocusedSupportingTextColor = Color(0xFF666666)
                    )
                )
            }
        },
        confirmButton = {
            Button(
                onClick = { onSubmit(rating, reviewText.trim().ifBlank { null }) },
                enabled = !isSaving && !isLoading,
                colors = ButtonDefaults.buttonColors(containerColor = BrandColors.Primary)
            ) {
                if (isSaving) {
                    CircularProgressIndicator(
                        modifier = Modifier.padding(horizontal = 8.dp),
                        strokeWidth = 2.dp,
                        color = Color.Black
                    )
                } else {
                    Text("Save", color = Color.Black)
                }
            }
        },
        dismissButton = {
            TextButton(onClick = onDismiss, enabled = !isSaving) {
                Text("Cancel", color = Color.Gray)
            }
        }
    )
}
